module.exports = __webpack_public_path__ + "static/media/bLIGHT.92be3588.png";